import React, { Component } from "react";
import { Form, Message } from "semantic-ui-react";
import { injectIntl } from "gatsby-plugin-intl";
import axios from "axios";
import validator from "validator";
import {
  categoryOptions,
  categoryOptionsKo,
  osOptions,
  PICPICK_LATEST_VERSION,
} from "../../constants";

class ContactForm extends Component {
  state = {
    from: "",
    text: "",
    license: "",
    os: null,
    version: "",
    category: null,
    error: false,
    submit: false,
    success: false,
    loading: false,
  };

  componentDidMount() {
    const { defaultCategory } = this.props;
    if (defaultCategory) {
      this.setState({
        category: defaultCategory,
      });
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { intl } = this.props;
    const { from, text, license, category, os, version, loading } = this.state;

    if (loading) {
      return;
    }

    this.setState(
      {
        submit: true,
        loading: true,
      },
      () => {
        if (
          this.validateError("category") ||
          this.validateError("from") ||
          this.validateError("text")
        ) {
          this.setState({
            loading: false,
          });
          return;
        }

        const categories =
          intl.locale === "ko" ? categoryOptionsKo : categoryOptions;

        const categoryText = category
          ? categories.find((option) => option.value === category).text
          : "";

        const osText = os
          ? osOptions.find((option) => option.value === os).text
          : undefined;

        axios
          .post("/netlify-api/contact", {
            category: categoryText,
            from,
            text,
            os: osText,
            license,
            version,
          })
          .then(() => {
            this.setState({
              from: "",
              text: "",
              license: "",
              version: "",
              os: null,
              category: null,
              error: false,
              success: true,
              submit: false,
              loading: false,
            });
          })
          .catch(() => {
            this.setState({
              success: false,
              error: true,
              loading: false,
            });
          });
      }
    );
  };

  handleChange = (e, { name, value }) => {
    this.setState({ [name]: value });
  };

  validateError(type) {
    const { submit, category, from, text } = this.state;
    let error = false;
    if (!submit) {
      return false;
    }

    switch (type) {
      case "category":
        error = category === null;
        break;
      case "from":
        error = !validator.isEmail(from);
        break;
      case "text":
        error = text === "";
        break;
      default:
    }
    return error;
  }

  render() {
    const { intl, defaultCategory } = this.props;
    const {
      from,
      text,
      license,
      category,
      os,
      version,
      success,
      error,
      loading,
    } = this.state;
    const categories =
      intl.locale === "ko" ? categoryOptionsKo : categoryOptions;

    const showLicense =
      intl.locale !== "ko" && category && category !== "sales";

    return (
      <Form onSubmit={this.handleSubmit}>
        <Form.Select
          fluid
          label={`${intl.formatMessage({ id: "contact_form_category" })}*`}
          options={categories}
          placeholder={intl.formatMessage({ id: "contact_form_select" })}
          name="category"
          value={category}
          onChange={this.handleChange}
          error={this.validateError("category")}
        />
        <Form.Input
          fluid
          label={`${intl.formatMessage({ id: "contact_form_email" })}*`}
          placeholder="your@email.com"
          name="from"
          value={from}
          onChange={this.handleChange}
          error={this.validateError("from")}
        />
        <Form.TextArea
          label={`${intl.formatMessage({ id: "contact_form_body" })}*`}
          placeholder={intl.formatMessage({
            id: "contact_form_body_placeholder",
          })}
          name="text"
          value={text}
          rows={6}
          onChange={this.handleChange}
          error={this.validateError("text")}
        />
        {category === "request" && (
          <Form.Select
            fluid
            label={intl.formatMessage({ id: "contact_form_os" })}
            options={osOptions}
            placeholder={intl.formatMessage({ id: "contact_form_select" })}
            name="os"
            value={os}
            onChange={this.handleChange}
            error={this.validateError("category")}
          />
        )}
        {category === "request" && (
          <Form.Input
            fluid
            label={intl.formatMessage({ id: "contact_form_version" })}
            placeholder={PICPICK_LATEST_VERSION}
            name="version"
            value={version}
            onChange={this.handleChange}
          />
        )}
        {showLicense && (
          <Form.Input
            fluid
            label={intl.formatMessage({ id: "contact_form_license" })}
            placeholder={intl.formatMessage({
              id: "contact_form_license_placeholder",
            })}
            name="license"
            value={license}
            onChange={this.handleChange}
          />
        )}
        <Form.Button primary size="huge" loading={loading} content="Submit" />
        {success && (
          <Message
            positive
            header={intl.formatMessage({ id: "contact_form_success" })}
            content={intl.formatMessage({
              id: "contact_form_success_description",
            })}
          />
        )}
        {error && (
          <Message
            negative
            header={intl.formatMessage({ id: "contact_form_error" })}
            content={intl.formatMessage({
              id: "contact_form_error_description",
            })}
          />
        )}
      </Form>
    );
  }
}

export default injectIntl(ContactForm);
